import React from 'react';
import { selectSnackbars } from 'modules/shared/stores/toasters-slice-handler';
import MuiSnackbar from '@mui/material/Snackbar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import SnackbarType from 'constants/snackbar-types';
import { useSelector } from 'react-redux';
import LayoutManager from 'utils/layout-manager';
import { Markup } from 'interweave';

function Snackbars() {
    const snackbars = useSelector(selectSnackbars);

    const iconTypeMap = {
        [SnackbarType.INFO]: <span className="stw-information snackbar-icon info" />,
        [SnackbarType.WARNING]: <span className="stw-exclamation-point snackbar-icon warning" />,
        [SnackbarType.SUCCESS]: <span className="stw-success snackbar-icon success" />,
        [SnackbarType.ERROR]: <span className="stw-cancel-close snackbar-icon error" />,
    };

    const position =
        LayoutManager.getDirection() === 'rtl'
            ? { vertical: 'top', horizontal: 'left' }
            : { vertical: 'top', horizontal: 'right' };

    /**
     * Render a snackbar element.
     * @param snackbarId
     * @param {SnackbarOptions} snackbarOptions
     * @return {JSX.Element}
     */
    const renderSnackbar = (snackbarId, snackbarOptions) => {
        return (
            <div className={'wcf-ui-toaster-manager'} key={snackbarId}>
                <MuiSnackbar open={true} anchorOrigin={position} className="snackbar" onClose={snackbarOptions.onClose}>
                    <Box className="snackbar-content">
                        {iconTypeMap[snackbarOptions.type]}
                        <Box>
                            <Typography variant="subtitle1">
                                <div className="snackbar-title">{snackbarOptions.title}</div>
                            </Typography>
                            <Typography variant="body2" className="snackbar-message">
                                <Markup content={snackbarOptions.message} />
                            </Typography>
                        </Box>
                        <span onClick={snackbarOptions.onClose} className="stw-cancel pointer snackbar-close" />
                    </Box>
                </MuiSnackbar>
            </div>
        );
    };

    return <>{Object.keys(snackbars).map((snackbarId) => renderSnackbar(snackbarId, snackbars[snackbarId]))}</>;
}

export default Snackbars;
